import Entity from "../../../class/abstract/Entity";

class License extends Entity {
    number = "";
    name = "";
    auth_id = 0;
    store_id = 0;
    type = "";
    settings = [];

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined)
                Reflect.set(this, key, datas[key]);
        }
    }
}

export default License;
